const translations = {
    DATE: "Date",
    TIME: "Time",
    HKD: "HKD",
    RMB: "RMB",
    USD: "USD",
    SGD: "SGD",
    CNY: "CNY",
    JPY: "HKD",
    MARKET_PRICE: "Market Price",
    PREVIOUS_CLOSE: "Previous Close",
    AS_OF: "As of",
};

export default translations;